import styled from 'styled-components'
import { orangeColor, orangePreLightColor, whiteColor } from '../../../constants/colors';

const LoadButtonBlock = styled.div`
  width: 100%;
  height: 54px;
  border-radius: 50px;
  background: ${orangePreLightColor};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
`

LoadButtonBlock.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

LoadButtonBlock.Process = styled.div`
  margin-bottom: 20px;
`

LoadButtonBlock.Line = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: ${orangeColor};
`
LoadButtonBlock.Text = styled.div`
  position: relative;
  z-index: 1;
  h2 {
    color: ${whiteColor};
  }
`

export {
  LoadButtonBlock
}